export const castBySchema = (schema, defaultOptions = {}) => (object, options = {}) =>
  schema.cast(object, { ...defaultOptions, ...options })
